/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../common/header/Header";
import Footer from "../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      a: "a",
      ul: "ul",
      li: "li",
      strong: "strong",
      em: "em"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | Copy that?"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "Copyright Infringement Claims"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsx(_components.h2, {
                    children: "Notification of Copyright Infringement Claims"
                  }), _jsxs(_components.p, {
                    children: ["Making original work is hard! As described in our ", _jsx(_components.a, {
                      href: "./abuse",
                      children: "Use Restrictions\npolicy"
                    }), ", you can’t use Modulabs products* to make or disseminate work\nthat uses the intellectual property of others beyond the bounds of ", _jsx(_components.a, {
                      href: "https://www.copyright.gov/fair-use/more-info.html",
                      children: "fair\nuse"
                    }), "."]
                  }), _jsx(_components.p, {
                    children: "Are you a copyright owner? Under the Digital Millennium Copyright Act (17 U.S.C. § 512), you\nhave the right to notify us (Modulabs, LLC) if you believe that an account user of any\nproduct we built and maintain has infringed on your work(s) as copyright owner. To be\neffective, the notification of claimed infringement must be written. Please include the\nfollowing information:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: "A physical or electronic signature of a person authorized to act on behalf of the owner of\nan exclusive right that is allegedly infringed."
                    }), "\n", _jsx(_components.li, {
                      children: "Identification of the copyrighted work(s) claimed to have been infringed. If there are\nmultiple, please share a representative list of those works."
                    }), "\n", _jsx(_components.li, {
                      children: "A way for us to locate the material you believe is infringing the copyrighted work."
                    }), "\n", _jsx(_components.li, {
                      children: "Your name and contact information so that we can get back to you. Email address is\npreferred."
                    }), "\n", _jsx(_components.li, {
                      children: "A statement that you, in good faith, believe that use of the material in the manner\ncomplained of is not authorized by the copyright owner, its agent, or the law."
                    }), "\n", _jsx(_components.li, {
                      children: "A statement that the information in the notification is accurate, and under penalty of\nperjury, that you are authorized to act on behalf of the owner of an exclusive right that is\nallegedly infringed."
                    }), "\n"]
                  }), _jsx(_components.h2, {
                    children: "Digital Millennium Copyright Act (“DCMA”) Counter-notifications"
                  }), _jsx(_components.p, {
                    children: "On the flip-side, if you believe your material has been removed in error, you can file a\nwritten counter-notification. Please include the following information:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: "A physical or electronic signature, or the signature of the person authorized to act on\nyour behalf."
                    }), "\n", _jsx(_components.li, {
                      children: "A description of the material that was removed."
                    }), "\n", _jsx(_components.li, {
                      children: "A description of where the material appeared in Modulabs products prior to their removal."
                    }), "\n", _jsx(_components.li, {
                      children: "Your name and contact information so that we can get back to you. Email address is\npreferred."
                    }), "\n", _jsx(_components.li, {
                      children: "A statement under penalty of perjury that you have a good faith belief that the material\nwas removed or disabled as a result of mistake or misidentification."
                    }), "\n", _jsx(_components.li, {
                      children: "A statement that you consent to the jurisdiction of the Federal District Court for the\njudicial district in which your address is located, or if your address is outside of the\nUnited States, in the Pennsylvania Western District Court (where Modulabs is located)."
                    }), "\n", _jsx(_components.li, {
                      children: "A statement that you will accept service of process from the person who filed the original\nDMCA notice or an agent of that person. (In other words, you’ve designated that person to\nreceive documents on your behalf.)"
                    }), "\n"]
                  }), _jsx(_components.h2, {
                    children: "Where to Send Notices"
                  }), _jsx(_components.p, {
                    children: "You can notify us of either copyright infringement claims or DCMA counter-notifications\nthrough either of the following channels:"
                  }), _jsxs(_components.p, {
                    children: [_jsx(_components.strong, {
                      children: "By email"
                    }), ": ", _jsx(_components.a, {
                      href: "mailto:report@modulabs.io",
                      children: "report@Modulabs.io"
                    })]
                  }), _jsxs(_components.p, {
                    children: ["*", _jsx(_components.em, {
                      children: "This policy and process applies to any product created and owned by Modulabs, LLC."
                    })]
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
